import { Box, Heading, Image, SimpleGrid, Text } from "@chakra-ui/react";
import ItemCard from "./ItemCard";

const SectionCardsPanel = ({ section, onItemClick, activeItemId }) => {
  if (!section) {
    return (
      <Box
        flex="1"
        px={8}
        py={8}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text fontSize="lg" color="gray.500">
          Select a section from the sidebar to view topics
        </Text>
      </Box>
    );
  }

  return (
    <Box flex="1" px={8} py={6}>
      {/* Section Header */}
      <Box mb={6}>
        <Heading as="h1" size="lg" color="teal.700" fontWeight="bold" mb={2}>
          {section.title}
        </Heading>
        <Text fontSize="md" color="gray.600">
          {section.items.length} topic{section.items.length !== 1 ? "s" : ""}{" "}
          available
        </Text>
      </Box>

      {/* Cards Grid */}
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
        {section.items.map((item) => (
          <ItemCard
            key={item.id}
            item={item}
            isActive={activeItemId === item.id}
            onClick={() => onItemClick(item)}
          />
        ))}
      </SimpleGrid>
      {section?.footerImg && (
        <Box py={4}>
          <Image src={section?.footerImg} alt={section.title} w="100%" />
        </Box>
      )}
    </Box>
  );
};

export default SectionCardsPanel;
